import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material';
import * as htmlToPdfmake from 'html-to-pdfmake';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Subscription } from 'rxjs/Subscription';
import Swal from 'sweetalert2';
import { LogService } from '../../../services/shared/log.service';
import { NGaugeService } from '../../../services/shared/ngauge.service';
import { UserService } from '../../../services/user.service';
import { EMAIL_PATTERN, EMAIL_SUGGESTIONS, LOG_LEVELS, LOG_MESSAGES, TINY_MCE_MAIL_BODY } from '../../../util/constants';
declare let tinymce: any;

@Component({
  selector: 'app-mail-document',
  templateUrl: './mail-document.component.html',
  styleUrls: ['./mail-document.component.css']
})
export class MailDocumentComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  @Input() pdf;
  @Input() accountDetails;
  @Input() docName;
  @Input() from;
  @Input() groupList;
  @Input() salesPersonTitle;
  @Input() functionDetails;
  @Input() toDate;
  @Input() weekDays;
  @Input() base64Image;
  @Input() pdfDocumentReport;
  @Input() signersLength;
  @Input() sendSignRequest;
  @Input() pdfName;
  @Input() mailIds;
  MailGroup: FormGroup;
  selectable = true;
  removable = true;
  addOnBlur = true;
  showMailBody = false;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  mails = [];
  today = new Date();
  userName;
  userJobTitle: any;
  mailContent: any;
  GROUP = 'Group';
  FUNCTION = 'Function';
  weekDay = '';
  emailList: { email: string; link: string; }[] = [];
  showCompose = false;
  sendSignRequestubscription: Subscription;
  signRequestSteps = false;
  signUrlId = 0;
  mailBodyInit = TINY_MCE_MAIL_BODY;
  sendSignUrlSubscription: Subscription;
  getSignUrlSubscrption: Subscription;
  repPrintSubscription: Subscription;

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private logService: LogService,
    private ngaugeService: NGaugeService) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }

  printDoc(res) {
    document.getElementById('docx').innerHTML = res['htmlCode'];
    const data = document.getElementById('docx').innerHTML;
    const html = htmlToPdfmake(data);
    const docDefinition = {
      content: [html],
      styles: {
        alignCenter: {
          alignment: 'center'
        },
        fullWidth: {
          width: '100% !important'
        },
        alignJustify: {
          alignment: 'justify'
        },
        marginTop: {
          marginTop: '20px'
        },
        marginBottom: {
          marginBottom: '20px'
        },
        fontBold: {
          bold: true
        },
        fontHuge: {
          fontSize: '18px'
        },
        marginLeft30: {
          marginLeft: '30px'
        },
        fontMedium: {
          fontSize: '16px'
        }
      }
    };
    document.getElementById('docx').innerHTML = '';
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.open();
    pdfDocGenerator.download(res['docName'] + '.pdf');
    /* To get base64 code */
    /* pdfDocGenerator.getBase64((base64: any) => {
      const base64Image = `data:application/pdf;base64,${base64}`;
    }); */
  }

  ngOnChanges() {
    tinymce.init({
      selector: '#textarea'
    });
  }

  ngAfterViewInit() {
    document.getElementById('docx').innerHTML = '';
  }

  ngOnInit() {
    this.MailGroup = this.buildMailGroup();
    if (this.docName === 'Group Agreement' || this.docName === 'Function Agreement') {
      this.signRequestSteps = true;
    }
    this.userName = this.groupList !== undefined ? this.groupList.salesPerson :
      (this.functionDetails !== undefined ? this.functionDetails.salesPerson : '');
    this.userJobTitle = this.salesPersonTitle !== undefined ? this.salesPersonTitle : '';
    this.getWeekDaysForFunction();
    setTimeout(() => {
      this.mails = this.mailIds !== undefined ? this.ngaugeService.isJSON(JSON.stringify(this.mailIds)) : [];
      if (this.sendSignRequest) {
        const value = {};
        value['type'] = this.docName;
        value['documentId'] = this.from === this.GROUP ? this.groupList['id'] : this.functionDetails['id'];
        this.getSignUrlSubscrption = this.ngaugeService.getSignUrls(value).subscribe(async res => {
          if (res['length'] > 0) {
            this.mails = [];
            this.mails[0] = res[0]['toUser'];
            const urls = this.ngaugeService.isJSON(res[0]['urlInfo']);
            this.emailList.push({
              email: res[0]['fromUser'],
              link: urls[0]
            });
            this.emailList.push({
              email: res[0]['toUser'],
              link: urls[1]
            });
            this.signUrlId = res[0]['id'];
            this.showCompose = true;
          } else {
            await this.sendSignRequestDetails();
            this.showCompose = true;
            this.logUserActivity('Sign Url Created', LOG_MESSAGES.SUCCESS);
          }
        }, error => {
          this.logService.logError(LOG_LEVELS.ERROR, 'On Mail Document Component', 'On fetch Sign Urls', JSON.stringify(error));
        });
      } else {
        this.showCompose = true;
      }
    }, 500);
    this.showMailBody = true;
    if (this.from === this.GROUP || this.from === this.FUNCTION) {
      setTimeout(async () => {
        const mailBody = await this.getTableBody();
        this.MailGroup.get('body').setValue(mailBody);
      }, 100);
    }
  }

  getWeekDaysForFunction() {
    if (this.weekDays !== undefined) {
      if (this.weekDays.length > 1) {
        this.weekDay = this.weekDays[0];
        for (let i = 1; i <= this.weekDays.length - 2; i++) {
          this.weekDay += ', ' + this.weekDays[i];
        }
        this.weekDay += ' and ' + this.weekDays[this.weekDays.length - 1];
      } else {
        this.weekDay = this.weekDays[0];
      }
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    // Add our mail
    if ((value || '').trim()) {
      this.mails.push(value.trim());
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    if (this.mails.length > 2) {
      this.mails.splice(this.mails.length - 1, 1);
    }
  }

  buildMailGroup(): FormGroup {
    return this.formBuilder.group({
      email: [''],
      subject: [''],
      body: ['']
    });
  }

  remove(mail): void {
    const index = this.mails.indexOf(mail);
    if (index >= 0) {
      this.mails.splice(index, 1);
    }
  }

  async sendMail() {
    let mailContent, text;
    if (this.MailGroup.get('body').dirty) {
      text = this.MailGroup.controls['body'].value.replace(/\n/g, '\n\n');
      text = text.replace(/<br\s*[\/]?>/gi, '\n');
    } else {
      text = await this.getTableBody();
    }
    mailContent = text.replace(/<\/?[^>]+(>|$)/g, '');
    setTimeout(() => {
      const mailToLink = `mailto:${this.mails}?subject=${this.MailGroup.controls['subject'].value}&body=${encodeURI(mailContent)}`;
      window.location.href = mailToLink;
      let fromText = '';
      if (this.docName.includes(this.GROUP)) {
        fromText = 'Group - Group Documents - Send Mail';
      } else if (this.docName.includes(this.FUNCTION)) {
        fromText = 'Function - Function Documents - Send Mail';
      } else if (this.docName === 'BEO - By Category') {
        fromText = 'Function - BEO - BEO Documents - Send Mail';
      } else if (this.docName === 'Account Continuous Call Report' || this.docName === 'Account Preferred Rate letter') {
        fromText = 'Account Documents - Send Mail';
      }
      this.logUserActivity(fromText, JSON.stringify(this.mails));
      this.logUserActivity(fromText, this.MailGroup.controls['subject'].value);
      this.logUserActivity(fromText, LOG_MESSAGES.CLICK);
    }, 1500);
  }

  getTableBody() {
    return new Promise(resolve => {
      let mailBodyHeader = '';
      if (this.from === this.GROUP) {
        mailBodyHeader = 'group-mail-body';
      } else if (this.from === this.FUNCTION) {
        mailBodyHeader = 'function-mail-body';
      } else {
        resolve(mailBodyHeader);
      }
      const mailBody = document.getElementById(mailBodyHeader).innerHTML;
      resolve(mailBody);
    });
  }

  generatePdf() {
    if (this.docName === 'Account Continuous Call Report') {
      this.ngaugeService.requestPrintData('ContinouscallReport');
      this.logUserActivity('Account Documents', 'Download File');
    } else if (this.docName === 'Group Proposal') {
      this.ngaugeService.requestPrintData('GroupProposalReport');
      this.logUserActivity('Group - Group Documents', 'Download File');
    } else {
      this.pdfDocumentReport.open();
      switch (this.docName) {
        case 'Account Preferred Rate letter':
          this.logAndDownload('Account Documents', 'LNR_Document.pdf');
          break;
        case 'Group Agreement':
          this.logAndDownload('Group - Group Documents', 'Group_Agreement.pdf');
          break;
        case 'Function Agreement':
          this.logAndDownload('Function - Function Documents', 'Function_Agreement.pdf');
          break;
        case 'BEO - By Category':
          this.logAndDownload('Function - BEO - BEO Documents', 'BEO_Agreement.pdf');
          break;
        case 'Group Resume':
          this.logAndDownload('Group - Group Documents', 'Group_Resume.pdf');
          break;
        case 'Function Resume':
          this.logAndDownload('Function - Function Documents', 'Function_Resume.pdf');
          break;
        case 'Group Proposal':
          this.logAndDownload('Group - Group Documents', 'Group_Proposal.pdf');
          break;
        case 'Group And Function Agreement':
          this.logAndDownload('Group - Group Documents', 'Group And Function Agreement.pdf');
          break;
      }
    }
  }

  logAndDownload(from, fileName) {
    this.logUserActivity(from, 'Download File');
    this.pdfDocumentReport.download(fileName);
  }

  sendSignRequestDetails() {
    return new Promise(resolve => {
      if (this.mails.length > 0) {
        let allValidMails = true;
        for (let i = 0; i < this.mails.length; i++) {
          const mail = this.mails[i];
          const validMail = EMAIL_PATTERN.test(mail) && !EMAIL_SUGGESTIONS.includes(mail);
          if (!validMail) {
            this.ngaugeService.toastrError(mail + '- Invalid Email');
            this.showCompose = true;
            allValidMails = false;
            break;
          }
        }
        if (allValidMails) {
          setTimeout(() => {
            this.sendSignRequestubscription = this.ngaugeService.sendSignRequest(
              this.base64Image, this.mails, this.pdfName).subscribe(request => {
                if (request['result'].length > 0) {
                  const params = {
                    property: this.userService.getLoggedInUserProperty(),
                    userId: this.userService.getLoggedInUserId(),
                    fromUser: request['result'][0]['email'],
                    toUser: request['result'][1]['email'],
                    type: this.docName,
                    urlInfo: JSON.stringify([request['result'][0]['link'], request['result'][1]['link']])
                  };
                  params['documentId'] = this.from === this.GROUP ? this.groupList['id'] : this.functionDetails['id'];
                  params['id'] = this.signUrlId;
                  this.sendSignUrlSubscription = this.ngaugeService.sendSignUrl(params).subscribe(() => {
                    if (this.signUrlId !== 0) {
                      this.logUserActivity('Sign Url - Regenerate', LOG_MESSAGES.SUCCESS);
                      this.ngaugeService.toastrSuccess('Sign url regenerated successfully');
                    }
                  }, error => {
                    this.logService.logError(LOG_LEVELS.ERROR, 'Mail Component', 'On Create/Update Sign Url', JSON.stringify(error));
                  });
                  this.mails.splice(0, 1);
                  this.emailList = request['result'];
                  resolve(true);
                } else {
                  this.ngaugeService.toastrError('Request for eSign fails');
                }
              }, error => {
                this.logService.logError(LOG_LEVELS.ERROR, 'On Mail Document Component', 'On try For Sign Request', JSON.stringify(error));
              });
          }, 2000);
        }
      }
    });
  }

  generateSignRequest() {
    this.logUserActivity('Regenerate Sign Url', LOG_MESSAGES.CLICK);
    const swalObject = {
      title: '<strong>Are you sure</strong>',
      text: 'Do you want to regenerate eSign link?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    };
    const primaryContactExist = this.ngaugeService.swalOkCancelButton(swalObject);
    Swal(primaryContactExist).then(async result => {
      if (result.value) {
        this.logUserActivity('Regenerate Sign Url - Confirmation', LOG_MESSAGES.YES);
        if (this.mailIds !== undefined) {
          this.mails = this.ngaugeService.isJSON(JSON.stringify(this.mailIds));
          if (this.sendSignRequest) {
            await this.sendSignRequestDetails();
          }
        }
      } else {
        this.logUserActivity('Regenerate Sign Url - Confirmation', LOG_MESSAGES.NO);
      }
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'On Mail Document Component', 'On regenerate sign url', JSON.stringify(error));
    });
  }

  logUserActivity(from, value) {
    this.logService.logUserActivity(LOG_LEVELS.INFO, from, value);
  }

  unSubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.unSubscribe(this.repPrintSubscription);
    this.unSubscribe(this.sendSignRequestubscription);
    this.unSubscribe(this.sendSignUrlSubscription);
    this.unSubscribe(this.getSignUrlSubscrption);
    this.ngaugeService.reqPrintValSub.next(null);
    this.accountDetails = null;
    this.mailBodyInit = null;
    this.docName = null;
    this.from = null;
    this.groupList = null;
    this.salesPersonTitle = null;
    this.functionDetails = null;
    this.toDate = null;
    this.weekDays = null;
    this.base64Image = null;
    this.pdfDocumentReport = null;
    this.signersLength = null;
    this.sendSignRequest = null;
    this.pdfName = null;
    this.mailIds = null;
    this.MailGroup = null;
    this.selectable = null;
    this.removable = null;
    this.addOnBlur = null;
    this.showMailBody = null;
    this.mails = null;
    this.today = null;
    this.userName = null;
    this.userJobTitle = null;
    this.mailContent = null;
    this.GROUP = null;
    this.FUNCTION = null;
    this.weekDay = null;
    this.emailList = null;
    this.showCompose = null;
    this.signUrlId = null;
    this.signRequestSteps = null;
    this.userService = null;
    this.formBuilder = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/account/support-components/mail-document/mail-document.component.ts